import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './checkbox.scss';

const Checkbox = ({ className, index, name, value, onChange, label, checked, disabled }) => (
  <div className={classnames('c-checkbox', className)} key={`checkbox-${index}`}>
    <input
      checked={checked}
      className="c-checkbox__input"
      disabled={disabled}
      id={`checkbox-${index}`}
      name={name}
      onChange={onChange}
      type="checkbox"
      value={value}
    />
    <label className="c-checkbox__label" htmlFor={`checkbox-${index}`}>
      <span className="c-checkbox__box">
        <span className="c-checkbox__box-check" />
      </span>
      <span className="c-checkbox__text">{label}</span>
    </label>
  </div>
);

Checkbox.propTypes = {
  className: PropTypes.string,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  index: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  label: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
};

Checkbox.defaultProps = {
  className: '',
};

export default Checkbox;
